import React from 'react'
import { useIntl } from 'react-intl'

import { SliteLogo, WebsiteNavbarLogo } from '@slite/components'

// Assuming Icon components are available, e.g., import { LogoIcon, CodeIcon, DownloadIcon } from '@slite/icons'

import { DlIcon, IdCodeIcon } from '@slite/icons'

import { useRoutes } from '../../routes'

export const NavbarLogo = () => {
  const intl = useIntl()
  const routes = useRoutes()
  return (
    <WebsiteNavbarLogo
      disableSwitch
      contextMenuItems={[
        {
          id: 'copyLogoAsSVG',
          onClick: () => {
            window.open(
              'https://storage.googleapis.com/slite-cdn/assets/2025/Slite_Symbol.svg',
              '_blank',
              'noopener,noreferrer'
            )
          },
          children: (
            <div className="flexbox flexbox-align-center flexbox-gap-12">
              <SliteLogo
                variant="symbol"
                width={16}
                height={16}
                className="shade-30"
              />
              <div>
                {intl.formatMessage({
                  id: 'slite.navbar.contextMenu.copyLogoAsSVG',
                  defaultMessage: 'Get logo as SVG',
                })}
              </div>
            </div>
          ),
        },
        {
          id: 'copyWordmarkAsSVG',
          onClick: () => {
            window.open(
              'https://storage.googleapis.com/slite-cdn/assets/2025/Slite_Wordmark.svg',
              '_blank',
              'noopener,noreferrer'
            )
          },
          children: (
            <div className="flexbox flexbox-align-center flexbox-gap-12">
              <IdCodeIcon size={14} className="shade-30" />
              <div>
                {intl.formatMessage({
                  id: 'slite.navbar.contextMenu.copyWordmarkAsSVG',
                  defaultMessage: 'Get wordmark as SVG',
                })}
              </div>
            </div>
          ),
        },
        {
          id: 'downloadBrandAssets',
          onClick: () => {
            window.open(
              routes.external.pressKit.url,
              '_blank',
              'noopener,noreferrer'
            )
          },
          children: (
            <div className="flexbox flexbox-align-center flexbox-gap-12">
              <DlIcon size={14} className="shade-30" />
              <div>
                {intl.formatMessage({
                  id: 'slite.navbar.contextMenu.downloadPressAssets',
                  defaultMessage: 'Download press kit',
                })}
              </div>
            </div>
          ),
        },
      ]}
      logo={
        <SliteLogo
          variant="wordmark"
          style={{ height: 24, paddingBottom: 4 }}
          className="shade-05"
        />
      }
      href={routes.home()}
    />
  )
}
